'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Navbar.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Navbar a container for navigational elements
 */
var Navbar = function Navbar(_ref) {
  var size = _ref.size,
    decorational = _ref.decorational,
    borderTop = _ref.borderTop,
    borderBottom = _ref.borderBottom,
    unpadded = _ref.unpadded,
    children = _ref.children;
  var baseNavbarClass = (0, _classnames2.default)('c-navbar', {
    'c-navbar--auto': size === 'auto'
  }, {
    'c-navbar--medium': size === 'medium'
  }, {
    'c-navbar--large': size === 'large'
  }, {
    'c-navbar--decorational': decorational
  }, {
    'c-navbar--bordered-top': borderTop
  }, {
    'c-navbar--bordered-bottom': borderBottom
  }, {
    'c-navbar--unpadded': unpadded
  });
  return _react2.default.createElement('div', {
    className: baseNavbarClass
  }, children);
};
Navbar.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Size of the navbar*/
  size: _propTypes2.default.oneOf(['auto', 'medium', 'large', 'decorational']),
  /** Whether the navbar is decorational or not and should be hidden if screen to small*/
  decorational: _propTypes2.default.bool,
  /** Renders border on top of the navbar*/
  borderTop: _propTypes2.default.bool,
  /** Renders border on bottom of the navbar*/
  borderBottom: _propTypes2.default.bool,
  /** Renders the navbar unpadded*/
  unpadded: _propTypes2.default.bool,
  /**Children of the navbar*/
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = Navbar;